module.exports = __webpack_public_path__ + "static/media/oero-icon.6d1e74eb.svg";